// Swipers

import Swiper, { Autoplay, Navigation, Pagination } from "swiper";

import 'swiper/css';

Swiper.use([Autoplay, Navigation, Pagination]);


const IndexSlider = new Swiper(".js-slider-index", {
  ...swiperArgs,
  slidesPerView: 1,
  grabCursor: false,
  loop: true,
  navigation: {
    nextEl: '.js-slider-index-next',
    prevEl: '.js-slider-index-prev',
  },
});

const relatedSlider = new Swiper(".js-related-products-slider", {
  ...swiperArgs,
  slidesPerView: 3,
  spaceBetween: 20,
  grabCursor: true,
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    // when window width is >= 678px
    678: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: '.js-related-products-next',
    prevEl: '.js-related-products-prev',
  },
});


// Front page HERO slider
if ( (document.querySelectorAll(".js-slider-index").length > 0) && (document.querySelectorAll(".js-slider-index .swiper-slide").length > 0) ) {
  IndexSlider;
}

// Product page related products slider
if ( (document.querySelectorAll(".js-related-products-slider").length > 0) && (document.querySelectorAll(".js-related-products-slider .swiper-slide").length > 0) ) {
  relatedSlider;
}



// Product page related products slider
if ( (document.querySelectorAll(".js-selling-points-slider").length > 0) && (document.querySelectorAll(".js-selling-points-slider .swiper-slide").length > 0) ) {
  for (const slider of document.querySelectorAll(".js-selling-points-slider")) {
    new Swiper(slider, {
      ...swiperArgs,
      slidesPerView: 1,
      grabCursor: true,
      pagination: {
        el: '.js-selling-points-pagination',
        type: 'bullets',
      },
    });
  }
}


// Hides navigation arrows if there is no elements to swipe
const toggleNavigation = () => {
  let allSwipers = [ IndexSlider, relatedSlider ];
  for (let index = 0; index < allSwipers.length; index++) {
      if ( isElement( allSwipers[index].el ) && allSwipers[index].navigation.$nextEl.length > 0 && allSwipers[index].navigation.$prevEl.length > 0 ) {
          if (allSwipers[index].isBeginning && allSwipers[index].isEnd ) {
              allSwipers[index].navigation.nextEl.style.display = 'none';
              allSwipers[index].navigation.prevEl.style.display = 'none';
          } else {
              allSwipers[index].navigation.nextEl.style.display = 'flex';
              allSwipers[index].navigation.prevEl.style.display = 'flex';
          }
      }
  }
};

// Swiper arguments repeating for all swipers
const swiperArgs = {
  autoplay: {
    delay: 4000,
  },
  on: {
      afterInit: toggleNavigation(this),
      onAfterResize: toggleNavigation(this),
  },
};

// Checks if passed element is HTML element
function isElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
}


